import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useParams, Link } from 'react-router-dom';

const { Box, SubTitle, Table, Icon } = vp;

type LinkedTransactionInfoProps = {
  LinkedTransactions: vp.LinkedTransactionsMap;
};

type FC = FunctionComponent<LinkedTransactionInfoProps>;

const LinkedTransactionInfo: FC = (props: LinkedTransactionInfoProps) => {
  const { LinkedTransactions } = props;
  const { accountId } = useParams<{ accountId: string }>();
  const subTransactionsAvailable = LinkedTransactions && LinkedTransactions.length > 0;

  const tableProps: vp.TableProps = {
    name: 'account-billing-settings-list',
    columns: {
      transactionID: { header: 'Transaction ID' },
      transactionStatus: { header: 'Status' },
      transactionType: { header: 'Transaction Type' },
      errorMessage: { header: 'Failure Reason' },
      timestamp: { header: 'Time stamp' },
      view: { header: 'View' },
    },
    rows:
      LinkedTransactions?.map((subTransaction) => ({
        transactionID: subTransaction.TransactionID,
        transactionStatus: subTransaction.TransactionStatus,
        transactionType: subTransaction.TransactionType,
        errorMessage: subTransaction.FailureReason,
        timestamp: subTransaction.Timestamp,
        view: shouldShowView(subTransaction) ? (
          <Link
            to={{
              pathname: `/accounts/${accountId}/${removeWhiteSpace(subTransaction)}/transaction/${
                subTransaction.TransactionID
              }`,
              search: new URLSearchParams({
                type: subTransaction.TransactionType,
              }).toString(),
            }}
          >
            <Box jc="center">
              <Icon icon="angleRight" size="xsm" />
            </Box>
          </Link>
        ) : (
          ''
        ),
      })) || [],
  };
  return (
    <div>
      {subTransactionsAvailable && (
        <Box mt="lg" mb="lg" flx="col">
          <SubTitle subTitle="Linked Transactions" />
        </Box>
      )}
      <Table {...tableProps} />
    </div>
  );

  function shouldShowView({ TransactionType }: vp.LinkedTransactions) {
    const isEFT = [vp.TransactionType.EFT_FUNDING, vp.TransactionType.EFT_WITHDRAWAL].includes(TransactionType);
    const isInteract = [vp.TransactionType.INTERACT_MONEY_REQUEST, vp.TransactionType.INTERACT_BULK_PAYOUT].includes(
      TransactionType,
    );
    const isCreditCard = [vp.TransactionType.CREDIT_CARD].includes(TransactionType);
    return isEFT || isInteract || isCreditCard;
  }

  function removeWhiteSpace({ TransactionType }: vp.LinkedTransactions) {
    return decodeURI(TransactionType).replaceAll(' ', '');
  }
};

export default LinkedTransactionInfo;
